<template>
  <v-dialog v-model="dialog" max-width="1200" scrollable>
    <v-card>

      <!-- Header -->
      <div style="background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%); padding: 16px 20px; display: flex; align-items: center; justify-content: space-between; gap: 12px;">
        <div class="d-flex align-center" style="gap: 12px;">
          <v-avatar color="rgba(255,255,255,0.15)" size="38">
            <v-icon color="white" size="20">mdi-school-outline</v-icon>
          </v-avatar>
          <div>
            <div style="font-size: 1rem; font-weight: 700; color: #fff;">Programas del Postgrado</div>
            <div v-if="postgrado" style="font-size: 0.75rem; color: rgba(255,255,255,0.65);">{{ postgrado.nombre }}</div>
          </div>
        </div>
        <v-btn icon dark small @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-0">

        <!-- Toolbar -->
        <div class="d-flex align-center px-4 py-2" style="gap:10px; border-bottom: 1px solid #e3e8f0;">
          <v-chip x-small :color="programas.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ programas.length }} programa{{ programas.length !== 1 ? 's' : '' }}
          </v-chip>
          <span style="font-size:0.78rem; color:#7986cb;">
            Programas implementados en las diferentes sedes
          </span>
        </div>

        <v-data-table
          :headers="headers"
          :items="programas"
          :items-per-page="-1"
          hide-default-footer
          dense
          class="pp-table"
          no-data-text="Sin programas registrados."
          :loading="!programas.length && !!postgrado"
          loading-text="Cargando..."
        >
          <template v-slot:[`item.fase`]="{ item }">
            <v-chip x-small label :color="faseColor(item.fase)" class="font-weight-medium">
              {{ item.fase }}
            </v-chip>
          </template>

          <template v-slot:[`item.inscritos`]="{ item }">
            <v-chip x-small label color="teal lighten-5" class="teal--text text--darken-2 font-weight-medium">
              {{ item.inscritos }}
            </v-chip>
          </template>

        </v-data-table>

      </v-card-text>

      <v-card-actions class="px-4 py-3" style="border-top: 1px solid #e3e8f0;">
        <v-spacer />
        <v-btn text @click="closeDialog">
          <v-icon left small>mdi-close</v-icon> Cerrar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import { parseFasePrograma, parseModalidadInverse } from '@/components/Utils.js';
import gql from 'graphql-tag';

export default {
  data() {
    return {
      dialog: false,
      postgrado: null,
      programas: [],
      headers: [
        { text: '#',         value: 'index',           width: 55,  sortable: false },
        { text: 'Código',    value: 'codigo',          width: 90 },
        { text: 'Nombre',    value: 'nombre_compuesto' },
        { text: 'Gestión',   value: 'gestion',         width: 80 },
        { text: 'Sede',      value: 'sede.nombre',     width: 140 },
        { text: 'Inicio',    value: 'fecha_inicio',    width: 100 },
        { text: 'Fin',       value: 'fecha_fin',       width: 100 },
        { text: 'Versión',   value: 'version',         width: 80 },
        { text: 'Fase',      value: 'fase',            width: 130 },
        { text: 'Inscritos', value: 'inscritos',       width: 90 },
      ],
    };
  },
  methods: {
    showThisView(item) {
      this.postgrado = item;
      this.programas = [];
      this.dialog = true;
      this.getDatos();
    },
    faseColor(fase) {
      if (typeof fase === 'string') {
        if (fase.toLowerCase().includes('inscripcion')) return 'green lighten-5 green--text text--darken-3';
        if (fase.toLowerCase().includes('desarrollo'))  return 'blue lighten-5 blue--text text--darken-3';
        if (fase.toLowerCase().includes('concluido') || fase.toLowerCase().includes('finalizado')) return 'grey lighten-3 grey--text text--darken-2';
      }
      return 'indigo lighten-5 indigo--text text--darken-2';
    },
    getDatos() {
      const qs = gql`query{ getPostgrado(id:${this.postgrado.id}){ programas{ id,codigo,nombre_compuesto,fecha_inicio,fecha_fin,version,estado,modalidad,gestion,fase,sede{nombre},inscripciones{id,estado_ins} } } }`;
      this.$apollo
        .query({ query: qs })
        .then(({ data: { getPostgrado } }) => {
          this.programas = getPostgrado.programas.map((program, i) => {
            program.index = ++i;
            program.fase = parseFasePrograma(program.fase);
            program.modalidad = parseModalidadInverse(program.modalidad);
            program.inscritos = program.inscripciones.filter((ins) => ins.estado_ins >= 1).length;
            program.pre_inscritos = program.inscripciones.filter((ins) => ins.estado_ins == 0).length;
            return program;
          });
        })
        .catch(() => this.$root.$notify.show('No hay datos', { color: 'primary' }));
    },
    closeDialog() {
      this.dialog = false;
      this.postgrado = null;
    },
  },
};
</script>

<style scoped>
.pp-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.pp-table >>> tbody tr:hover { background: #f0f4ff !important; }
.pp-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
</style>
